
(function() {
  var result = { translations: { "en": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanian", "sq-al": "Albanian - Albania", "ar": "Arabic", "ar-dz": "Arabic - Algeria", "ar-bh": "Arabic - Bahrain", "ar-eg": "Arabic - Egypt", "ar-iq": "Arabic - Iraq", "ar-jo": "Arabic - Jordan", "ar-kw": "Arabic - Kuwait", "ar-lb": "Arabic - Lebanon", "ar-ly": "Arabic - Libya", "ar-ma": "Arabic - Morocco", "ar-om": "Arabic - Oman", "ar-qa": "Arabic - Qatar", "ar-sa": "Arabic - Saudi Arabia", "ar-sd": "Arabic - Sudan", "ar-sy": "Arabic - Syria", "ar-tn": "Arabic - Tunisia", "ar-ae": "Arabic - United Arab Emirates", "ar-ye": "Arabic - Yemen", "as": "Assamese", "az": "Azerbaijani", "hy": "Armenian", "eu": "Basque", "be": "Belarusian", "be-by": "Belarusian - Belarus", "bn": "Bengali", "bg": "Bulgarian", "bg-bg": "Bulgarian - Bulgaria", "bs": "Bosnian", "ca": "Catalan", "ca-es": "Catalan - Catalan", "zh": "Chinese", "zh-cn": "Chinese - Simplified", "zh-hk": "Chinese - Hong Kong", "zh-mo": "Chinese - Macau", "zh-sg": "Chinese - Singapore", "zh-tw": "Chinese - Traditional", "zh-chs": "Chinese (Simplified)", "zh-cht": "Chinese (Traditional)", "zh-hans": "Chinese (Simplified Han)", "zh-hant": "Chinese (Traditional Han)", "hr": "Croatian", "hr-hr": "Croatian - Croatia", "cs": "Czech", "cs-cz": "Czech - Czech Republic", "da": "Danish", "da-dk": "Danish - Denmark", "nl": "Dutch", "nl-be": "Dutch - Belgium", "nl-ch": "Dutch - Switzerland", "nl-lu": "Dutch - Luxembourg", "nl-nl": "Dutch - The Netherlands", "en": "English", "en-ae": "English - United Arab Emirates", "en-au": "English - Australia", "en-be": "English - Belgium", "en-ca": "English - Canada", "en-ch": "English - Switzerland", "en-cn": "English - China", "en-de": "English - Germany", "en-ee": "English - Estonia", "en-es": "English - Spain", "en-fr": "English - France", "en-hk": "English - Hong Kong", "en-in": "English - India", "en-ie": "English - Ireland", "en-ke": "English - Kenya", "en-lu": "English - Luxembourg", "en-my": "English - Malaysia", "en-mt": "English - Malta", "en-mx": "English - Mexico", "en-nl": "English - The Netherlands", "en-nz": "English - New Zealand", "en-ph": "English - Philippines", "en-pk": "English - Pakistan", "en-se": "English - Sweden", "en-sg": "English - Singapore", "en-tn": "English - Tunisia", "en-za": "English - South Africa", "en-gb": "English - United Kingdom", "en-us": "English - United States", "en-zw": "English - Zimbabwe", "et": "Estonian", "et-ee": "Estonian - Estonia", "fo": "Faroese", "fa": "Farsi", "fi": "Finnish", "fi-fi": "Finnish - Finland", "fil": "Filipino", "fr": "French", "fr-be": "French - Belgium", "fr-ca": "French - Canada", "fr-fr": "French - France", "fr-lu": "French - Luxembourg", "fr-mc": "French - Monaco", "fr-ch": "French - Switzerland", "fr-tn": "French - Tunisia", "gl": "Galician", "ka": "Georgian", "de": "German", "de-at": "German - Austria", "de-de": "German - Germany", "de-gr": "German - Greece", "de-li": "German - Liechtenstein", "de-lu": "German - Luxembourg", "de-ch": "German - Switzerland", "el": "Greek", "el-cy": "Greek - Cyprus", "el-gr": "Greek - Greece", "gu": "Gujarati", "haw": "\u02BB\u014Clelo Hawai\u02BBi", "ha": "Hausa", "he": "Hebrew", "he-il": "Hebrew - Israel", "iw-il": "Hebrew - Israel", "hi": "Hindi", "hi-in": "Hindi - India", "hu": "Hungarian", "hu-hu": "Hungarian - Hungary", "is": "Icelandic", "is-is": "Icelandic - Iceland", "id": "Indonesian", "in-id": "Indonesian - Indonesia", "ga": "Irish", "ga-ie": "Irish - Ireland", "it": "Italian", "it-it": "Italian - Italy", "it-ch": "Italian - Switzerland", "ja": "Japanese", "ja-jp": "Japanese - Japan", "kn": "Kannada", "kk": "Kazakh", "kok": "Konkani", "ko": "Korean", "ko-kr": "Korean - South Korea", "ku": "Kurdish", "ky": "Kyrgyz", "ky-kg": "Kyrgyz", "lo": "Lao", "lv": "Latvian", "lv-lv": "Latvian - Latvia", "lt": "Lithuanian", "lt-lt": "Lithuanian - Lithuania", "mk": "Macedonian", "mk-mk": "Macedonian - Macedonia", "ml": "Malayalam", "ms": "Malay", "ms-bn": "Malay - Brunei", "ms-my": "Malay - Malaysia", "mt": "Maltese", "mt-mt": "Maltese - Malta", "mr": "Marathi", "mn": "Mongolian", "my": "Burmese", "my-mm": "Burmese - Myanmar (Burma)", "ne": "Nepali", "no": "Norwegian", "nb": "Norwegian Bokmal", "nb-no": "Norwegian Bokmal - Norway", "no-no": "Norwegian - Norway", "pl": "Polish", "pl-pl": "Polish - Poland", "pt": "Portuguese", "pt-br": "Portuguese - Brazil", "pt-pt": "Portuguese - Portugal", "pa": "Punjabi", "pa-in": "Punjabi - India", "pa-pk": "Punjabi - Pakistan", "ro": "Romanian", "ro-ro": "Romanian - Romania", "ru": "Russian", "ru-ru": "Russian - Russia", "rw-rw": "Kinyarwanda", "sa": "Sanskrit", "si": "Sinhala", "sr": "Serbian", "sr-ba": "Serbian - Bosnia and Herzegovina", "sr-me": "Serbian - Montenegro", "sr-rs": "Serbian - Serbia", "sr-cs": "Serbian - Serbia and Montenegro (Former)", "sk": "Slovak", "sk-sk": "Slovak - Slovakia", "sl": "Slovenian", "sl-si": "Slovenian - Slovenia", "es": "Spanish", "es-ar": "Spanish - Argentina", "es-bo": "Spanish - Bolivia", "es-cl": "Spanish - Chile", "es-co": "Spanish - Colombia", "es-cr": "Spanish - Costa Rica", "es-cu": "Spanish - Cuba", "es-do": "Spanish - Dominican Republic", "es-ec": "Spanish - Ecuador", "es-sv": "Spanish - El Salvador", "es-gt": "Spanish - Guatemala", "es-hn": "Spanish - Honduras", "es-mx": "Spanish - Mexico", "es-ni": "Spanish - Nicaragua", "es-pa": "Spanish - Panama", "es-py": "Spanish - Paraguay", "es-pe": "Spanish - Peru", "es-pr": "Spanish - Puerto Rico", "es-es": "Spanish - Spain", "es-us": "Spanish - United States", "es-uy": "Spanish - Uruguay", "es-ve": "Spanish - Venezuela", "sw": "Swahili", "sv": "Swedish", "sv-fi": "Swedish - Finland", "sv-se": "Swedish - Sweden", "sy": "Syriac", "ta": "Tamil", "tt": "Tatar", "te": "Telugu", "th": "Thai", "th-th": "Thai - Thailand", "tl": "Tagalog", "tr": "Turkish", "tr-tr": "Turkish - T\xFCrkiye", "uk": "Ukrainian", "uk-ua": "Ukrainian - Ukraine", "ur": "Urdu", "uz": "Uzbek", "vi": "Vietnamese", "vi-vn": "Vietnamese - Vietnam", "yi": "Yiddish", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "en": { "videoData": { "time": { "abbreviations": { "hour": "hr", "minute": "min", "second": "sec" } } } } } };
  result.translationsLoaded = {
  "video-data-lib": {
    "en": "static-1.28370"
  }
};
  result.translationsAvailable = {
  "video-data-lib": {
    "da": "static-1.28370",
    "de": "static-1.28370",
    "en": "static-1.28370",
    "es": "static-1.28370",
    "fi": "static-1.28370",
    "fr": "static-1.28370",
    "it": "static-1.28370",
    "ja": "static-1.28370",
    "ko": "static-1.28370",
    "nl": "static-1.28370",
    "no": "static-1.28370",
    "pl": "static-1.28370",
    "pt-br": "static-1.28370",
    "sv": "static-1.28370",
    "th": "static-1.28370",
    "zh-cn": "static-1.28370",
    "zh-tw": "static-1.28370"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-data-lib:en', {version: 'static-1.28370'}); }
})();



(function() {
  var result = { translations: { "en": { "videoPlayer": { "htmlTitle": "HubSpot Video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot Video", "controls": { "audioPlayer": "Audio player", "videoPlayer": "Video player", "play": "Play", "playVideo": "Play video", "pause": "Pause", "replay": "Replay", "currentTime": "Current time", "duration": "Duration", "remainingTime": "Remaining time", "fullscreen": "Fullscreen", "exitFullscreen": "Exit Fullscreen", "mute": "Mute", "unmute": "Unmute", "volumeLevel": "Volume level", "captions": "Captions", "captionsOff": "Off", "seekBar": "Adjust position", "chapter": "Chapter", "elapsedTime": "Elapsed time: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Playback options", "playbackRate": "Playback speed:", "quality": "Quality:", "normal": "Normal", "auto": "(Auto)" }, "formModal": { "defaultThankYouMessage": "Thanks for your response!", "inlineMessageButton": "Watch video" }, "ctaModal": { "imgAlt": "Video CTA" }, "errors": { "generic": { "heading": "Could not load video" }, "UNAUTHORIZED": { "heading": "Video not enabled" }, "VIDEO_NOT_FOUND": { "heading": "Video not found" }, "INVALID_URL": { "heading": "Video not found" }, "UNSUPPORTED_EMBED": { "heading": "Video not available", "extra": "This video can't be viewed externally." }, "refreshLink": "Try again" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "en": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:en', {version: 'static-1.29208'}); }
})();


